import { t } from "@/i18n-js/instance";
import { LineItem } from "./LineItem";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

interface DueTodayProps {
  dueToday: string;
}

export const DueToday = ({ dueToday }: DueTodayProps) => (
  <LineItem
    description={t([localeRoot, "due_today"])}
    value={dueToday}
    descriptionProps={{
      weight: "font-medium",
    }}
    valueProps={{
      weight: "font-medium",
    }}
  />
);
